import * as React from "react";

interface Props {
  width: number
  height: number
}

const DocumentZipIcon = ({ width = 800, height = 800, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <radialGradient
        id="a"
        cx={-428.363}
        cy={-337.616}
        r={0.076}
        gradientTransform="matrix(22.426, -0.918, 0.944, 23.053, 9940.275, 7417.533)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ffffff" />
        <stop offset={1} stopColor="#41c3f3" />
      </radialGradient>
      <linearGradient
        id="b"
        x1={-414.07}
        y1={-323.688}
        x2={-413.475}
        y2={-323.688}
        gradientTransform="translate(3599.15 2562.224) rotate(-2.754) scale(8.352)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#3dc2f3" />
        <stop offset={1} stopColor="#ffffff" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={-466.763}
        y1={-351.799}
        x2={-466.168}
        y2={-351.799}
        gradientTransform="translate(-3224.585 -2139.318) rotate(176.688) scale(6.683)"
        xlinkHref="#b"
      />
      <linearGradient
        id="d"
        x1={-515.182}
        y1={-375.873}
        x2={-514.587}
        y2={-375.873}
        gradientTransform="matrix(-2.607, 0.014, -0.014, -2.607, -1327.883, -959.089)"
        xlinkHref="#b"
      />
      <linearGradient
        id="e"
        x1={-413.465}
        y1={-322.372}
        x2={-412.869}
        y2={-322.372}
        gradientTransform="translate(3557.82 2614.61) rotate(-1.63) scale(8.403)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0995dd" />
        <stop offset={1} stopColor="#ffffff" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={-515.182}
        y1={-373.034}
        x2={-514.587}
        y2={-373.034}
        gradientTransform="matrix(-2.607, 0.014, -0.014, -2.607, -1327.785, -940.81)"
        xlinkHref="#b"
      />
      <linearGradient
        id="g"
        x1={-415.664}
        y1={-321.968}
        x2={-415.069}
        y2={-321.968}
        gradientTransform="translate(3992.128 2325.757) rotate(-7.749) scale(8.752)"
        xlinkHref="#e"
      />
      <radialGradient
        id="h"
        cx={-435.908}
        cy={-337.858}
        r={0.076}
        gradientTransform="matrix(22.426, -0.918, 0.944, 23.053, 10123.552, 7416.068)"
        xlinkHref="#a"
      />
      <linearGradient
        id="i"
        x1={-397.199}
        y1={-317.443}
        x2={-396.604}
        y2={-317.443}
        gradientTransform="translate(1942.918 1600.128) rotate(0.719) scale(4.876)"
        xlinkHref="#b"
      />
    </defs>
    <title>{"file_type_zip2"}</title>
    <path
      d="M9.832,2l7.415.053a2,2,0,0,1,2.054.936l.67.819h5.672c.5.032.8.175.949.446A2.8,2.8,0,0,1,26.684,5.3l.019.913c.008,1.534-.388,1.533-1.009,1.523l-1.31.017,0,11.741a8.05,8.05,0,0,1,.846.019c.621.011,1.19.005,1.191,1.366-.009.224-.017.45-.01.621a2.2,2.2,0,0,0,0,.569c-.032.5-.07.83-.3,1.047-.18.231-.487.312-.988.28-.277-.024-.516.021-.741.012l-.016,2.207c.105.031.225.007.33.039.156.045.329.04.419.121a1.43,1.43,0,0,1,1.124,1.4l1.952.113a.587.587,0,0,1,.227-.388.754.754,0,0,1,.524-.245l.053.015a.9.9,0,0,1,.79.8l-.015.053.012.741a.942.942,0,0,1-.286.6,1.194,1.194,0,0,1-.577.229.753.753,0,0,1-.546-.271.425.425,0,0,1-.148-.271l-2.082.134a1.6,1.6,0,0,1-.452.777,2.156,2.156,0,0,1-1.513.525l-2.9.011a2.421,2.421,0,0,1-1.585-.4,1.483,1.483,0,0,1-.482-.877l-3.2-.133a.518.518,0,0,1-.211.335.866.866,0,0,1-.577.23.745.745,0,0,1-.56-.219.868.868,0,0,1-.23-.577l0-.794a.754.754,0,0,1,.271-.545.6.6,0,0,1,.577-.23.745.745,0,0,1,.56.219.428.428,0,0,1,.149.27l3.2-.264a1.928,1.928,0,0,1,.6-.9,2.406,2.406,0,0,1,1.274-.48l.016-2.208c-.292.028-.568,0-.913.019l-1.247,1.169a2.482,2.482,0,0,1-2.158.793c-1.19-.005-2.5.012-3.809.029-1.243-.02-2.484-.04-3.847-.038a2.971,2.971,0,0,1-1.144-.162,3.342,3.342,0,0,1-1.052-.872,5.746,5.746,0,0,1-.469-.533c-.127-.15-.253-.3-.469-.533a.763.763,0,0,1-.164-.218.467.467,0,0,1,.106-.367c.067-.037.15-.126.218-.163.172-.007.359-.066.532-.073,1.415.013,3.053.035,4.639.041s3.173.013,4.812.035a2.273,2.273,0,0,0,1-.333,5.376,5.376,0,0,0,.833-.722c.88-.88,2.044-1.96,2.837-1.957a.5.5,0,0,1,.277.023l.033-11.848-.4,0a1.545,1.545,0,0,1-1.4-.634l-1.377-1.7c-.633-.75-.633-.75-1.546-.732L7.55,4.572c-.517.02-1.429.04-.805-.744l.827-.9A3.127,3.127,0,0,1,8.66,2.115,5.06,5.06,0,0,1,9.828,2"
      style={{
        fill: "#2e2a2b",
      }}
    />
    <path
      d="M15.366,27.055l-.005.018-.041.007-.041.007-.018-.007-.082.015-.018-.007-.128.04-.028.03-.041.007-.016.054-.046.025-.018-.007-.016.054-.016.054-.016.054-.016.054-.016.054-.016.054-.016.054.022.123-.005.018-.01.035.022.123-.016.054.012.158-.016.054-.016.054.031.028.008.041-.016.054-.016.054.048.033-.01.035.038.069.043.051-.005.018.054.015.038.069.054.015c.028.051.092.068.173.07l.077,0,.082-.015a.45.45,0,0,0,.164-.03l.051-.044.018.007.016-.054.085-.092.016-.054.016-.054.016-.054.016-.054.016-.054.01-.035-.038-.069.031-.107-.017-.141.026-.089-.022-.123.016-.054.016-.054-.038-.069.016-.054.01-.035-.031-.028-.008-.041-.013-.023-.025-.046-.038-.069-.02-.064-.054-.015-.145-.1-.089-.026Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <polygon
      points="19.234 27.352 19.111 27.375 19.058 27.36 18.935 27.382 18.776 27.394 18.723 27.379 18.6 27.402 18.477 27.424 18.355 27.447 18.247 27.415 18.13 27.419 18.025 27.447 17.972 27.432 17.849 27.454 17.672 27.462 17.619 27.446 17.496 27.469 17.373 27.491 17.32 27.476 17.161 27.488 17.039 27.511 16.985 27.495 16.862 27.518 16.74 27.54 16.632 27.509 16.51 27.531 16.405 27.559 16.399 27.577 16.336 27.597 16.282 27.582 16.106 27.589 16.085 28.261 16.154 28.222 16.244 28.248 16.366 28.226 16.42 28.241 16.473 28.256 16.65 28.249 16.703 28.264 16.757 28.28 16.88 28.257 16.933 28.273 17.022 28.299 17.145 28.276 17.199 28.291 17.375 28.284 17.429 28.3 17.482 28.315 17.605 28.292 17.659 28.308 17.766 28.339 17.871 28.311 17.924 28.327 18.047 28.304 18.154 28.335 18.208 28.351 18.33 28.328 18.384 28.344 18.437 28.359 18.596 28.347 18.65 28.362 18.703 28.377 18.82 28.373 18.928 28.404 19.05 28.382 19.104 28.397 19.158 28.412 19.28 28.39 19.287 27.366 19.233 27.35 19.234 27.352"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M24.59,26.043a.777.777,0,0,1-.176.007c-.1-.03-.162-.047-.23-.007l-.054-.015-.054-.015-.335.019-.176.007-.176.007-.158.012-.337-.039-.353.014-.158.012-.176.007-.176.007-.367-.068L21.31,26l-.123.022-.054-.015-.064.02-.059,0a1.327,1.327,0,0,0-.3.088,1.161,1.161,0,0,0-.174.066l-.087.033a.406.406,0,0,0-.156.071l-.074.056-.11.045-.016.054c-.053-.015-.071.038-.138.076l-.044.084-.033.048-.09.11-.01.035a.967.967,0,0,0-.124.429l-.018,1.2A1.128,1.128,0,0,0,19.8,29l.007.041c.037.067.06.134.165.164l.079.061.084.044a.551.551,0,0,0,.15.082l.031.028.071.021.089.026c.1.03.215.006.319.034s.234.007.391.055l.005-.018.018.007.1-.009.054.015.158-.012.176-.007.176-.007.337.039.158-.012.176-.007.176-.007.171.011.158-.012.176-.007.337.039.335-.019.036.011h.194c.067-.037,0,0,.054.015l.1-.028c.106-.012.209,0,.317-.024a.942.942,0,0,0,.174-.066.936.936,0,0,0,.325-.119l.005-.018a.588.588,0,0,0,.143-.094l.005-.018L25.3,29.2l.023-.012.074-.056a1.072,1.072,0,0,0,.162-.224.881.881,0,0,0,.227-.515.344.344,0,0,0,.009-.23l0-1.006-.01-.1a.681.681,0,0,0-.108-.361.562.562,0,0,0-.229-.279,1.075,1.075,0,0,0-.183-.169L25,26.166l-.107-.031-.25-.073-.054-.015Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M23.876,7.715l-.335.019-.337-.04-.335.019-.176.007-.176.007-.278-.042-.281.035-.176.007-.23-.009-.028,2.432L21.53,16l.009.235,0,2.654-.01.636.077,0,.1-.009a.531.531,0,0,0,.235-.01,1.656,1.656,0,0,1,.26.037l.1-.009.077,0a.811.811,0,0,1,.176-.007c.12-.023.215,0,.335-.019.052.015.055.016.123-.022l.089.026a.824.824,0,0,0,.276-.017l.041-.007a2.009,2.009,0,0,1,.266.019,1.4,1.4,0,0,1,.141-.018l.036.011c.052.015.054.015.069-.038l.019-2.2-.014-2.889.007-2.961-.007-.176-.007-2.713,0-.794-.059,0,.005-.018Z"
      style={{
        fill: "url(#d)",
      }}
    />
    <path
      d="M25.9,4.263a2.521,2.521,0,0,1-.283-.024l-.276.017-.572-.03h-.736l-.741.017-.687.033-.388,0H21.48L20.7,4.227l-.759.012-.051.043-.2-.116-.076-.138-.674-.815a2.164,2.164,0,0,0-.313-.323,1.118,1.118,0,0,0-.471-.311,2.133,2.133,0,0,0-.763-.105l-.123.022-.266-.019-.353.014-.779-.052h-.736l-.741.017h-.406l-.741.017-.388,0-.72-.054-.253,0-.153-.006L11,2.439l-.388,0-.353.014-.442-.012c-.119.022-.226-.025-.294.012-.135,0-.29,0-.388,0a1.279,1.279,0,0,0-.315.083l-.069.038a1.308,1.308,0,0,0-.2.078,1.45,1.45,0,0,0-.19.119l-.028.031a1.919,1.919,0,0,0-.385.392L7.1,4.136a2.047,2.047,0,0,1,.4.02L8.679,4.15l.353-.014h1.142l.741-.017.779.052.335-.019.794,0h1.142l.335-.019h.406l.725.036h.194l.207.021.565-.011c.07,0,.115-.007.176-.007.156-.007.272-.009.388,0a1.219,1.219,0,0,1,.686.238,3.355,3.355,0,0,1,.381.42,1.089,1.089,0,0,1,.209.215l.485.664.712.884.183.169a1.878,1.878,0,0,0,.209.215l.018.005a1.451,1.451,0,0,0,.326.211,1.558,1.558,0,0,0,.391.055.173.173,0,0,0,.158-.012l.225.026h.406l.725.036.335-.019.353-.014.388,0h1.142l.353-.014.388,0h.406l.266.019.054.016.1-.01a.319.319,0,0,0,.325-.254,3.266,3.266,0,0,0,.052-.779l.045-.955c0-.068-.005-.114-.007-.176-.013-.345,0-.562-.084-.644-.022-.12-.133-.155-.29-.2ZM23.874,7.7l.055.81,0-.794L23.874,7.7Z"
      style={{
        fill: "url(#e)",
      }}
    />
    <path
      d="M23.876,23.365l-.005.018-.117,0-.054-.015-.117,0-.054-.015-.069.038-.161-.047-.005.018-.064.02-.089-.026-.069.038-.161-.047-.051.044-.018-.007-.107-.031-.069.038-.107-.031-.123.022-.036-.011-.123.022-.071-.021-.158.012-.054-.015c-.068.037-.071.038-.123.022l-.077,0a.258.258,0,0,1-.153,0l-.036-.011L21.6,23.4l-.041.007-.023.012-.023.613.021,1.129v.406l.054.015.054.015.158-.012.054.015.123-.022.054.015.176-.007.054.015.123-.022.054.015.158-.012.054.015.123-.022.054.015L23,25.587l.054.015.117,0,.054.015.158-.012.054.015.123-.022.054.015.176-.007.054.015.005-.018.064-.02,0-.794v-.135l.021-1.272-.054-.015Z"
      style={{
        fill: "url(#f)",
      }}
    />
    <path
      d="M25.542,19.973a1.57,1.57,0,0,0-.237-.049l-.069.038a.5.5,0,0,0-.171-.011,2.583,2.583,0,0,0-.623.013c-.142,0-.276.008-.388,0a3.98,3.98,0,0,1-.46-.02,3.534,3.534,0,0,1-.388,0l-.1.009-.077,0-.117,0c-.1.009-.219.011-.353.014a3.682,3.682,0,0,0-.618,0,3.69,3.69,0,0,1-.388,0c-.113,0-.233-.007-.347,0l-.112-.014c-.068.037-.16.012-.228.05a.2.2,0,0,0-.176.007l-.146.035-.082.015-.151.053-.005.018a8.1,8.1,0,0,0-.763.5c-.117.108-.223.219-.346.326l-.046.025-.056.061c-.093.077-.192.15-.3.224-.083.089-.168.2-.259.293l-.08.074a1.176,1.176,0,0,1-.223.168c-.083.089-.1.127-.164.165l-.005.018a2.265,2.265,0,0,1-.672.58l-.016.054a5.191,5.191,0,0,1-.765.3,1.5,1.5,0,0,1-.2.037l-.041.007a.84.84,0,0,1-.171-.011l-.046.025-.023.012c-.1-.031-.216-.007-.373-.05a4.353,4.353,0,0,1-.593.041,4.292,4.292,0,0,0-.524,0c-.106,0-.215-.019-.324-.016-.219-.007-.439,0-.654-.014-.277-.024-.517.025-.794,0l-.041.007-.059,0c-.12,0-.241-.017-.36-.027-.293.029-.572.011-.863.04a.406.406,0,0,0-.23-.007c-.052-.015-.086-.043-.153,0-.14,0-.281-.008-.406,0a4.247,4.247,0,0,1-.442-.013c-.136,0-.273.01-.406,0a4.249,4.249,0,0,1-.442-.013c-.059.011-.131,0-.194,0s-.142,0-.212,0c-.292.028-.566-.007-.858.022a4.549,4.549,0,0,0-.848-.014c-.167,0-.333,0-.5-.009-.057,0-.114-.009-.171-.011l-.123.022c-.078.014-.15.036-.228.05l-.016.054a1.663,1.663,0,0,1,.387.4l.081.12a1.712,1.712,0,0,1,.188.152l.148.159.013.023a.3.3,0,0,0,.183.169,1.572,1.572,0,0,0,.29.336l.013.023.048.033a1.675,1.675,0,0,0,.407.331l.107.031.357.1c.113,0,.263,0,.406,0h.212l.094.009.135,0c.277.024.566.008.843.032l.141-.017c.088.009.178.011.266.019.278-.027.546-.01.822-.033l.041-.007a4.606,4.606,0,0,0,.848.014c.224.007.442.03.666.038.172-.006.34-.019.565-.01.146-.015.294-.008.429-.011.269-.022.53,0,.8-.02.057,0,.114.011.171.011a3.859,3.859,0,0,0,.7.008c.136,0,.273-.01.406,0s.253,0,.388,0c.12-.022.233.007.353-.014l.107.031c.292-.029.532-.081.772-.125l.023-.012.018.007c.084-.021.141-.033.21-.055a1.435,1.435,0,0,0,.156-.071l.046-.025a2.2,2.2,0,0,0,.241-.162l.1-.069.005-.018c.052-.047.108-.092.159-.148l.169-.183.182-.16.192-.2.387-.333.4-.387.174-.066.094.009.082-.015c.133.011.27,0,.406,0,.277.024.571-.01.848.014.239-.024.466,0,.7-.01l.158-.012a.17.17,0,0,0,.158-.012l.112.014.117,0c.128,0,.263,0,.406,0,.277.024.571-.009.848.014.292-.029.572-.011.863-.04.07,0,.137.019.207.022a1.918,1.918,0,0,0,.6-.059l.085-.092A1.285,1.285,0,0,0,26,22.063a2.921,2.921,0,0,1-.011-.565,2.092,2.092,0,0,1,.01-.636c-.008-.107-.02-.2-.035-.281a1.147,1.147,0,0,0-.063-.251l-.058-.133-.025-.046-.079-.061-.008-.041-.071-.021-.12-.054Z"
      style={{
        fill: "url(#g)",
      }}
    />
    <path
      d="M28.993,27l-.117,0-.059,0-.028.03-.041.007-.01.035-.059,0-.016.054-.051.043-.01.035-.016.054-.016.054-.016.054-.016.054-.016.054-.016.054,0,.118-.005.018-.005.018L28.5,27.7l.008.041.015.082-.031.107.028.1-.016.054-.016.054.038.069-.016.054-.016.054.031.028.008.041.013.023.01.1.054.015.038.069.054.015.038.069.107.031.143.041c.058-.031.151-.063.22-.091l.041-.007.051-.043.033-.048.069-.038.005-.018.01-.035.016-.054.016-.054.016-.054.016-.054.01-.035-.038-.069.016-.054.016-.054-.007-.176.016-.054-.007-.176-.022-.123.016-.054.01-.035-.013-.023-.013-.023-.013-.023.016-.054-.018-.007-.02-.064-.018-.007-.056-.074a.055.055,0,0,1-.038-.069l-.107-.031-.054-.015a1.383,1.383,0,0,0-.161-.047Z"
      style={{
        fill: "url(#h)",
      }}
    />
    <path
      d="M4.416,5.513H17.121a.2.2,0,0,1,.142.1l.074.135.012,13.449-.061.209-1,.9-1,.9-.068.037-.067.037L2.463,21.227c-.1-.031-.247-.129-.216-.234L2.219,7.6l.015-.053a.168.168,0,0,1,.082-.089L4.225,5.57a.29.29,0,0,1,.188-.059"
      style={{
        fill: "#b3272c",
      }}
    />
    <polyline
      points="16.556 5.989 4.488 5.947 2.992 7.386 14.995 7.464 16.557 5.989"
      style={{
        fill: "#f46d22",
      }}
    />
    <polyline
      points="16.854 6.287 15.343 7.778 15.355 15.948 15.328 20.536 15.96 19.924 16.876 19.112 16.854 6.288"
      style={{
        fill: "#f46d22",
      }}
    />
    <polyline
      points="14.89 20.807 14.898 7.875 2.658 7.84 2.649 20.772 14.89 20.807"
      style={{
        fill: "#f6e216",
      }}
    />
    <path
      d="M12.807,15.689l.662-.716-.018,4.363L4.209,19.32l.646-.664,7.944-.019,0-2.948ZM6.973,11.16l3.57.014.027.689L7,11.849l-.027-.689Zm5.819-1.091.032,3.015-7.932-.032-.7.649,9.3.031,0-4.311-.7.649Zm-5.8,6.713-.026.674,3.569.015.025-.674-3.569-.015"
      style={{
        fill: "#2e2a2b",
      }}
    />
    <path
      d="M12.807,10.036,4.875,10l.032,3.016-.7.649,0-4.311,9.3.031-.7.649Zm.014,5.62.662-.716-9.3-.031.034,4.377.646-.664.02-3,7.932.033"
      style={{
        fill: "#ec771d",
      }}
    />
    <polygon
      points="27.982 27.59 27.976 27.608 27.912 27.628 27.859 27.613 27.752 27.582 27.647 27.609 27.593 27.594 27.54 27.579 27.417 27.601 27.363 27.586 27.256 27.555 27.251 27.572 27.187 27.592 27.133 27.577 27.026 27.546 26.909 27.55 26.855 27.535 26.766 27.509 26.761 27.527 26.697 27.547 26.643 27.531 26.536 27.5 26.467 27.538 26.413 27.523 26.36 27.508 26.306 27.493 26.301 27.51 26.237 27.53 26.216 28.202 26.226 28.302 26.224 28.378 26.277 28.394 26.4 28.371 26.454 28.387 26.577 28.364 26.612 28.375 26.735 28.352 26.853 28.348 26.906 28.363 27.029 28.341 27.082 28.356 27.205 28.334 27.259 28.349 27.381 28.327 27.435 28.342 27.486 28.299 27.54 28.314 27.663 28.292 27.716 28.307 27.839 28.285 27.892 28.3 27.898 28.282 27.962 28.262 28.015 28.278 28.069 28.293 28.074 28.275 28.138 28.255 28.191 28.27 28.196 27.652 28.143 27.637 28.089 27.621 27.982 27.59 27.982 27.59"
      style={{
        fill: "url(#i)",
      }}
    />
    <path
      d="M12.807,10.036,4.875,10l.032,3.016-.7.649,0-4.311,9.3.031-.7.649Zm.014,5.62.662-.716-9.3-.031.034,4.377.646-.664.02-3,7.932.033"
      style={{
        fill: "#ec771d",
      }}
    />
    <path
      d="M20.9,9.083l3.385-.719.1.03a.746.746,0,0,1,.591.115A.975.975,0,0,1,25.293,9l-.015.052a.329.329,0,0,1-.009.224c-.015.052.022.12-.046.157a.855.855,0,0,1-.683.6l-3.438.7-.052-.015a.773.773,0,0,1-.591-.115.965.965,0,0,1-.313-.488l-.038-.067a.329.329,0,0,0,.009-.224l.046-.157a.9.9,0,0,1,.736-.58Zm-.177,8.23,3.475-.637.068-.038a1.1,1.1,0,0,1,.575.167.529.529,0,0,1,.312.488l.037.067.007.173-.061.209a.984.984,0,0,1-.736.58l-3.422.652c-.067.037-.067.037-.12.021a.633.633,0,0,1-.523-.152.791.791,0,0,1-.38-.45l.03-.1a.2.2,0,0,1-.007-.172l.046-.157a1.013,1.013,0,0,1,.7-.648Zm.128-5.522a1.013,1.013,0,0,0-.7.649l-.046.157a.411.411,0,0,0-.008.225l-.015.052a.864.864,0,0,0,.365.5.666.666,0,0,0,.538.1l.052.015,3.438-.705a.983.983,0,0,0,.736-.581l.046-.157c.03-.1-.007-.172.009-.224l-.037-.067a.624.624,0,0,0-.312-.488.787.787,0,0,0-.59-.114l-.053-.015-3.422.652Zm-.063,2.761a1.07,1.07,0,0,0-.751.633l-.046.157a.2.2,0,0,1,.006.172l-.015.052.038.068a1.473,1.473,0,0,0,.313.487.773.773,0,0,0,.591.114l.052.015,3.49-.689a.921.921,0,0,0,.683-.6l.061-.209a.2.2,0,0,0-.007-.172l.015-.052a.727.727,0,0,0-.312-.488,1.122,1.122,0,0,0-.576-.167c-.067.037-.067.037-.119.022l-3.422.652"
      style={{
        fill: "#2e2a2b",
      }}
    />
  </svg>
);
export default DocumentZipIcon;
